export const formatDateTime = (date: Date): string => {
  return date.toLocaleString();
};
